import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PharmacyNav = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("/pharmacy");
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/pharmacy",
      "/pharmacy/scanner",
      "/pharmacy/new-patient",
      "/pharmacy/patient-list",
      "/pharmacy/patients",
      "/pharmacy/pos",
      "/pharmacy/pos/add",
      "/pharmacy/free-medicine",
      "/pharmacy/prescription",
      "/pharmacy/new-medicine",
      "/pharmacy/medicine-list",
      "/pharmacy/medicine-category",
      "/pharmacy/medicine-company",
      "/pharmacy/purchase-drug",
      "/pharmacy/return-medicine",
      "/pharmacy/return-to-company",
      "/pharmacy/return-to-company/add",
      "/pharmacy/medicine-stock",
    ];

    if (path.startsWith("/pharmacy/scanner")) {
      setValue("/pharmacy/scanner");
    } else if (path.startsWith("/pharmacy/pos")) {
      setValue("/pharmacy/pos");
    } else if (path.startsWith("/pharmacy/prescription")) {
      setValue("/pharmacy/prescription");
    } else if (path.startsWith("/pharmacy/free-medicine")) {
      setValue("/pharmacy/free-medicine");
    } else if (path.startsWith("/pharmacy/purchase-drug")) {
      setValue("/pharmacy/purchase-drug");
    } else if (path.startsWith("/pharmacy/return-medicine")) {
      setValue("/pharmacy/return-medicine");
    } else if (path.startsWith("/pharmacy/return-to-company")) {
      setValue("/pharmacy/return-to-company");
    } else if (path.startsWith("/pharmacy/medicine-company")) {
      setValue("/pharmacy/medicine-company");
    } else if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/pharmacy");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            {[
              { path: "/pharmacy", label: t("pharmacy.dashboard") },
              {
                path: "/pharmacy/scanner",
                label: t("pharmacy.scanner"),
              },
              {
                path: "/pharmacy/new-patient",
                label: t("reception.newPatient"),
              },
              {
                path: "/pharmacy/patient-list",
                label: t("reception.patientList"),
              },
              {
                path: "/pharmacy/pos",
                label: t("pharmacy.pos"),
              },
              {
                path: "/pharmacy/free-medicine",
                label: t("pharmacy.freeMedicine"),
              },
              {
                path: "/pharmacy/prescription",
                label: t("pharmacy.prescription"),
              },
              {
                path: "/pharmacy/new-medicine",
                label: t("pharmacy.new_medicine"),
              },
              {
                path: "/pharmacy/medicine-list",
                label: t("pharmacy.medicine_list"),
              },
              {
                path: "/pharmacy/medicine-category",
                label: t("pharmacy.medicineCategories"),
              },
              {
                path: "/pharmacy/medicine-company",
                label: t("pharmacy.medicineCompany"),
              },
              {
                path: "/pharmacy/purchase-drug",
                label: t("pharmacy.purchase_drug"),
              },
              {
                path: "/pharmacy/return-medicine",
                label: t("pharmacy.return_medicine"),
              },

              {
                path: "/pharmacy/return-to-company",
                label: t("pharmacy.returnToCompany"),
              },
              {
                path: "/pharmacy/medicine-stock",
                label: t("pharmacy.medicine_stock"),
              },
            ].map((tab, index) => {
              const isSelected = value === tab.path;
              return (
                <Tab
                  key={index}
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    backgroundColor: isSelected
                      ? theme.palette.primary.main
                      : "white",
                    color: isSelected ? "white" : "black",
                  }}
                  label={tab.label}
                  value={tab.path}
                  component={NavLink}
                  to={tab.path}
                />
              );
            })}
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default PharmacyNav;
